<template>
  <div class="app-container" style="padding:0">
    <ul>
      <template v-if="vo.passenger.subjects && vo.passenger.subjects.length > 0 ">
        <li v-for="(item,index) in vo.passenger.subjects" :key="index">
          <div v-if="item.subject !== null" class="manngerItem" @click="editClick(item,index,0)">
            <div>  {{ index + 1 }} . {{ item.subject }}  </div>
            <div>
              <span v-if="canEdit === 1" class="Fright" style="margin-right:10px" @click.stop="editClick(item,index,1)"> <i class="el-icon-edit" /> </span>
              <span v-if="canEdit === 1" class="Fright" @click.stop="delsub(index)"> <i class="el-icon-delete" /> </span>
            </div>
          </div>
          <div class="content">
            <template>
              <ul>
                <el-radio-group v-if="item.voteType === 1" v-model="item.checkedValue" :disabled="canEdit === 'no'" class="widthall">
                  <li v-for="(choice, _index) in item.passenger.choices" :key="_index" class="opiton" :checked="choice.checked">
                    <el-radio disabled :label="choice.id">{{ choice.subject }}</el-radio>
                    <img v-if="choice.coverUrl !== null&&!choice.imgUrl" class="img-box img-box1" :src="base_api+'/hygl/vote/download?dataField=voteFile&nameField=voteFileName&id='+ choice.id" style="margin-bottom:10px">
                    <img v-if="choice.imgUrl" class="img-box img-box2" :src="choice.imgUrl" style="margin-bottom:10px">
                  </li>
                </el-radio-group>
                <el-checkbox-group v-if="item.voteType === 2" v-model="item.checkedValue" :disabled="canEdit === 'no'" class="widthall">
                  <li v-for="(choice, _index) in item.passenger.choices" :key="_index" class="opiton" :checked="choice.checked">
                    <el-checkbox disabled :label="choice.id">{{ choice.subject }}</el-checkbox>
                    <img v-if="choice.coverUrl !== null&&!choice.imgUrl" class="img-box" :src="base_api+'/hygl/vote/download?dataField=voteFile&nameField=voteFileName&id='+ choice.id" style="margin-bottom:10px">
                    <img v-if="choice.imgUrl" class="img-box" :src="choice.imgUrl" style="margin-bottom:10px">
                  </li>
                </el-checkbox-group>
              </ul>
            </template>
          </div>
        </li>
      </template>
      <li v-if="canEdit === 1">
        <div v-if="vo.passenger.subjects" class="line" style="width: 100%;height: 1px;background: #DBE3EC;"></div>
        <div class="header-table-title" style="text-align:center;margin:30px">
          <span class="Fright"><el-button v-text-lbl="'hygl.voteManage.addTopic'" type="primary" size="mini" icon="el-icon-plus" @click="AddNewMannger">添加题目</el-button></span>
        </div>
      </li>
      <!-- <template v-else>
        <li>
          <div class="null-subject"> 点击右上方按钮添加题目 </div>
        </li>
      </template> -->
    </ul>
    <!-- 添加题目 -->
    <el-dialog v-if="showAdd" v-el-drag-dialog append-to-body :visible.sync="showAdd" :close-on-click-modal="false" width="1000px" title="新增题目" @close="closeAddDialog">
      <voting-content v-if="showAdd" ref="votingcontent" :subject-data="subjectVo" :can-edit="topPicEdit" :vo="vo" />
      <div slot="footer" class="dialog-footer">
        <el-button v-pageBtn-lbl="'close'" :disabled="buttondisabled" plain @click="closeAddDialog"> 关 闭 </el-button>
        <el-button v-if="topPicEdit===1" v-pageBtn-lbl="'save'" :disabled="buttondisabled" type="primary" @click="AddNewExam"> 保 存 </el-button>
        <el-button v-if="topPicEdit===0&&canEdit===1" v-pageBtn-lbl="'update'" :disabled="buttondisabled" type="primary" @click="editNewExam"> 修改 </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// this.$options.components['VotingContent'] = this.$loadComponent('@/hygl/hygl/voteManage/votingContent')
import votingContent from '../votingContent'
export default {
    components: {
        votingContent
    },
    props: {
        moduleInfo: { type: Object, default: function() { return {} } },
        canEdit: { type: Number, default: 1 },
        vo: { type: Object, default: function() { return {} } }
    },
    data() {
        return {
            showAdd: false,
            showit: false,
            buttondisabled: false,
            base_api: process.env.VUE_APP_BASE_API,
            urlInfo: {
                addSubjectUrl: 'hygl/voteSubject/addNew',
                insertSubjectUrl: 'hygl/voteSubject/insert',
                addVoteChoices: 'hygl/voteChoices/addNew',
                delVoteChoices: 'hygl/voteChoices/delete'
            },
            topPicEdit: 1,
            subjectVo: {},
            fileList: {},
            num: 1,
            imgUrl: []
        }
    },
    computed: {

    },
    watch: {
    },
    created() {
        if (!this.vo.isnew) this.showit = true
        this.$bus.on('voteUploadFile', this.startUploadFile)
        // if (this.canEdit === 1 && JSON.stringify(this.vo.passenger) === '{}') this.addSubject()
    },
    beforeDestroy() {
        this.$bus.off('voteUploadFile', this.startUploadFile)
    },
    mounted() {
    },
    methods: {
        AddNewMannger() {
            this.topPicEdit = 1
            this.addSubject()
        },
        editNewExam() {
            this.topPicEdit = 1
            this.showAdd = false
            this.$nextTick(() => {
                this.showAdd = true
            })
        },
        editClick(item, index, edit) {
            this.topPicEdit = edit
            this.subjectVo = JSON.parse(JSON.stringify(item))
            this.showAdd = true
        },
        closeAddDialog() {
            this.subjectVo.passenger.choices.forEach(item => {
                delete this.fileList[item.id]
            })

            this.showAdd = false
        },
        addSubject() {
            this.$http({
                method: 'POST',
                contentType: 'application/x-www-form-urlencoded',
                url: this.urlInfo.addSubjectUrl
            }).then(res => {
                if (res.code === 'success') {
                    const subObj = res.body.vo
                    subObj.voteId = this.vo.id
                    subObj.status = 1
                    subObj.voteType = 1
                    subObj.passenger.choices = []

                    this.itemAdd(subObj)
                    this.itemAdd(subObj)

                    this.$forceUpdate()
                } else {
                    this.$alert(res.message, this.$tx('common.operationTip', '操作提示'), { type: 'error' })
                }
            })
        },
        // 新增选项
        itemAdd(subObj) {
            this.$http({
                method: 'POST',
                contentType: 'application/x-www-form-urlencoded',
                url: this.urlInfo.addVoteChoices
            }).then(res => {
                if (res.code === 'success') {
                    const choiceObj = res.body.vo
                    choiceObj.status = 1
                    choiceObj.subjectId = subObj.id
                    choiceObj.isnew = true

                    subObj.passenger.choices.push(choiceObj)

                    this.subjectVo = subObj

                    this.$forceUpdate()
                    this.$nextTick(() => {
                        this.showAdd = true
                    })
                } else {
                    this.$alert(res.message, this.$tx('common.operationTip', '操作提示'), { type: 'error' })
                }
            })
        },
        insertSubject() {
            this.$http({
                method: 'POST',
                contentType: 'application/x-www-form-urlencoded',
                url: this.urlInfo.insertSubjectUrl,
                data: this.vo
            }).then(res => {
                if (res.code === 'success') {
                    this.$forceUpdate()
                } else {
                    this.$alert(res.message, this.$tx('common.operationTip', '操作提示'), { type: 'error' })
                }
            })
        },
        // 添加题目
        AddNewExam() {
            // this.showit = false
            // this.addSubject()
            this.$forceUpdate()
            const copySubjectVo = JSON.parse(JSON.stringify(this.subjectVo))
            console.log('this.imgUrl', this.imgUrl)
            if (this.vo.passenger.subjects) {
                if (this.imgUrl.length > 0 && copySubjectVo.passenger.choices && copySubjectVo.passenger.choices.length > 0) {
                    copySubjectVo.passenger.choices.forEach(res => {
                        this.imgUrl.forEach(val => {
                            if (val.id === res.id) {
                                res.imgUrl = val.url
                            }
                        })
                    })
                }
                let i = null
                this.vo.passenger.subjects.forEach((item, index) => {
                    if (item.id === copySubjectVo.id) {
                        i = index
                    }
                })

                if (i !== null) {
                    this.vo.passenger.subjects[i] = copySubjectVo
                } else {
                    this.vo.passenger.subjects.push(copySubjectVo)
                }
            } else {
                this.vo.passenger.subjects = []
                if (this.imgUrl.length > 0 && copySubjectVo.passenger.choices && copySubjectVo.passenger.choices.length > 0) {
                    copySubjectVo.passenger.choices.forEach(res => {
                        this.imgUrl.forEach(val => {
                            if (val.id === res.id) {
                                res.imgUrl = val.url
                            }
                        })
                    })
                }
                this.vo.passenger.subjects.push(copySubjectVo)
            }
            console.log('this.vo', this.vo)
            this.closedialog()
        },
        // 上传图片
        startUploadFile(reloadList) {
            const _this = this
            if (JSON.stringify(this.fileList) !== '{}') {
                for (const key in this.fileList) {
                    const config = {}
                    this.$app.upload('/hygl/vote/upload', this.fileList[key][0].raw, { 'id': key, 'nameField': 'coverUrl', 'dataField': 'cover' }, config).then(res => {
                        if (_this.num === Object.keys(_this.fileList).length) {
                            reloadList()
                        }
                        _this.num++
                    })
                }
            } else {
                reloadList()
            }
        },
        // 删除题目
        delsub(index) {
            this.$delete(this.vo.passenger.subjects, index)
            this.$forceUpdate()
        },
        closedialog() {
            this.showAdd = false
        }
    }
}
</script>

<style scoped lang="scss">
ul li{
    list-style: none;
}
.Fright{
    cursor: pointer;
}
ul{
    margin-block-start: 0;
    margin-block-end: 0;
    margin-inline-start: 0px;
    padding-inline-start: 0px;
   // padding-bottom: 30px;
}
.manngerItem{
    height: 48px;
    line-height: 48px;
    color: #1E1E1E;
    font-size: var(--portalFontSize14);
   // margin-top: 15px;
    display: flex;
    justify-content: space-between;
    padding: 0 22px;
    cursor: pointer;
    background: #F2F5FB;
    border-bottom: 1px solid #DBE3EC;
}
.null-subject{
    height: 200px;
    width: 100%;
    line-height: 200px;
    text-align: center;
}
.content{
    ul li{
        list-style: none;
    }
    .subject{
        font-weight: bold;
        font-size: 16px;
        color: #333;
    }
    .opiton{
        padding-left: 16px;
        font-size: var(--portalFontSize14);
        line-height: 40px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        position: relative;
        // margin-bottom: 20px;
        .img-box{
            width: 270px;
           height: 160px;
            display: block;
        }
    }
    .true-box{
        position: absolute;
        top: calc(50% - 14px);
        right: 20px;
    }
    /deep/ .el-checkbox-group{
        .el-checkbox__label{
            color:#606266;
        }
    }
    /deep/ .el-radio-group {
        .el-radio__label{
            color:#606266;
        }
    }
}
</style>
